/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

interface DragHandleProps {
  size?: number
  color?: string
}

const DragHandle = ({ size = 16, color = '#e3e3e3' }: DragHandleProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={`${size}px`}
      viewBox='0 -960 960 960'
      width={`${size}px`}
      fill={color}
      css={css`
        transform: rotate(90deg);
      `}
    >
      <path d='M360-160q-33 0-56.5-23.5T280-240q0-33 23.5-56.5T360-320q33 0 56.5 23.5T440-240q0 33-23.5 56.5T360-160Zm240 0q-33 0-56.5-23.5T520-240q0-33 23.5-56.5T600-320q33 0 56.5 23.5T680-240q0 33-23.5 56.5T600-160ZM360-400q-33 0-56.5-23.5T280-480q0-33 23.5-56.5T360-560q33 0 56.5 23.5T440-480q0 33-23.5 56.5T360-400Zm240 0q-33 0-56.5-23.5T520-480q0-33 23.5-56.5T600-560q33 0 56.5 23.5T680-480q0 33-23.5 56.5T600-400ZM360-640q-33 0-56.5-23.5T280-720q0-33 23.5-56.5T360-800q33 0 56.5 23.5T440-720q0 33-23.5 56.5T360-640Zm240 0q-33 0-56.5-23.5T520-720q0-33 23.5-56.5T600-800q33 0 56.5 23.5T680-720q0 33-23.5 56.5T600-640Z' />
    </svg>
  )
}

export default DragHandle
